import { Component, OnInit, OnDestroy, Inject, Injector } from '@angular/core'
import { Route, Router } from '@angular/router'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { LAZY_LOADER } from 'api/providers'
import { LocaleService } from 'common/locale/module'
import { RouteLoggerService } from 'common/util/module'
import { UploaderService } from 'main/services/uploader.service'
// import { NavigationErrorModalComponent } from 'root/components/navigationErrorView.component'
import { LazyLoaderService } from '../services/lazyLoader.service'

async function loadAngularJS () {
  await Promise.all([
    import('../../vendor.ng1'),
    import('../../app'),
  ])
}

const ANGULAR_JS_ROUTES = [
  '/ui-test',
  '/workstation/:id',
  '/workstation',
  '/workspace/deleted',
  '/workspace/:id',
  '/workspace',
  '/workspace-folder-templates/:id',
  '/workspace-folder-templates',
  '/user/ldap/:id',
  '/user/group/ldap/:id',
  '/user/group/:id',
  '/user/:userId/audit',
  '/user/:id',
  '/user',
  '/tasks/report/:id',
  '/tasks/pending',
  '/tasks/job/:id',
  '/tasks',
  '/system/log',
  '/system',
  '/status/trace',
  '/status/alerts/notification/:id',
  '/status/alerts',
  '/status/advanced-logs/:id',
  '/status/advanced-statistics/:id',
  '/status',
  '/share/:id',
  '/share',
  '/profile/api-playground',
  '/profile',
  '/production/:id',
  '/production',
  '/panel/media/search/:rootId',
  '/panel/media/browse/:rootId/:id',
  '/panel',
  '/media/view/file/:rootId/:id',
  '/media/view/file/:id',
  '/media/view/:rootId/:id',
  '/media/view/:rootId/:dirId/:id',
  '/media/upload/:rootId/:id',
  '/media/subtitle/:rootId/:fileId',
  '/media/shared-items/:id',
  '/media/search/folder/:directoryId',
  '/media/search/:rootId/',
  '/media/search/:rootId',
  '/media/search',
  '/media/root/:id',
  '/media/editor/:rootId/:fileId',
  '/media/compare/:rootId/:ids',
  '/media/browse/flat/:rootId/:id',
  '/media/browse/flat/:rootId',
  '/media/browse/file/:id',
  '/media/browse/:rootId/:id',
  '/media',
  '/download',
  '/download-archive/create',
  '/download-archive/:id',
  '/download-archive',
  '/archive/tapes/ungrouped',
  '/archive/tapes/group/:id',
  '/archive/tapes/browse/tape/:id',
  '/archive/tapes/browse/:id',
  '/archive/tapes/:id',
  '/archive/tapes',
  '/archive/start',
  '/archive/search',
  '/archive/restore',
  '/archive/library',
  '/archive/jobs/log/:id',
  '/archive/jobs/files/:id',
  '/archive/jobs',
  '/ai/models/:id',
  '/ai/:connection_id/datasets/:dataset_id/categories/:id',
  '/ai/:connection_id/datasets/:dataset_id/categories/:category_id/tracks/:id',
  '/ai/:connection_id/datasets/:dataset_id',
  '/ai',
  '/about',
  '/',
]

@Component({
  selector: 'angular-js',
  template: '',
  styles: [`
    :host {
      display: none;
      overflow-y: auto;
    }
  `],
})
export class AngularJSComponent implements OnInit, OnDestroy {
  static containerParent: HTMLElement
  static containerElement: HTMLElement|undefined

  constructor (
    @Inject(LAZY_LOADER) private lazyLoader: LazyLoaderService,
    private injector: Injector,
    private ngbModal: NgbModal,
    private router: Router,
    private routeLogger: RouteLoggerService,
    private locale: LocaleService,
    private uploader: UploaderService,
  ) {
    if (!AngularJSComponent.containerElement) {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      AngularJSComponent.containerElement = document.querySelector('.angular-js-container') as any
      AngularJSComponent.containerParent = AngularJSComponent.containerElement!.parentElement!
    }
  }

  routeChangeStart = () => {
    this.routeLogger.setRouteIsChanging(true)
    this.uploader.deactivate()
  }

  routeChangeSuccess = () => {
    if (this.router.routerState.snapshot.root.firstChild?.component === AngularJSComponent) {
      this.routeLogger.setRouteIsChanging(false)
    }
  }
  routeChangeError = (_$event, _current, _previous, error) => {
    this.routeLogger.setRouteIsChanging(false)
    this.routeLogger.lastError = error
    // history.pushState(null, '', lastURL)
    this.router.navigate(['/navigation-error'], { skipLocationChange: true })
    // modal.componentInstance.reason ='route-error'
    // modal.result.catch(() => null)
  }

  async ngOnInit () {
    document.body.classList.toggle('angular-js-mode', true)
    await this.lazyLoader.load($injector => {
      $injector.get('$rootScope').$on('$routeChangeStart', this.routeChangeStart)
      $injector.get('$rootScope').$on('$routeChangeSuccess', this.routeChangeSuccess)
      $injector.get('$rootScope').$on('$routeChangeError', this.routeChangeError)
      $injector.get('angularJSLocale').setLocale(this.locale.getLocale())
      $injector.get('angularJSLocale').setCatalog(this.locale.getCatalog())
    })
  }

  ngOnDestroy () {
    document.body.classList.toggle('angular-js-mode', false)
  }

  static ROUTES: Route[] = ANGULAR_JS_ROUTES.map(url => ({
    path: url.slice(1),
    pathMatch: 'prefix',
    component: AngularJSComponent,
    resolve: {
      _: loadAngularJS,
    },
    data: {
      reuseRoute: true,
      ignoreEvents: true,
    },
  }))
}
